export const MERGE = 'merge';
export const OVERWRITE = 'overwrite';

export { requiredFields, blacklistedFields, shouldDisplayRow } from 'components/properties/merge/helpers';
